import { render, staticRenderFns } from "./CadastroPanels.vue?vue&type=template&id=9d1f8fac&scoped=true"
import script from "./CadastroPanels.vue?vue&type=script&lang=js"
export * from "./CadastroPanels.vue?vue&type=script&lang=js"
import style0 from "./CadastroPanels.vue?vue&type=style&index=0&id=9d1f8fac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1f8fac",
  null
  
)

export default component.exports